import HTTP from "../../utility/http";
import { asyncHandler } from "@/utility/async";

const state = {
  photographers: [],
};

const getters = {
  getPhotographers: (state) => state.photographers,
};

const actions = {
  async all({ commit }) {
    const resp = await asyncHandler(
      HTTP({
        url: "photographer/all",
        method: "GET",
      })
    );
    if (resp.success) {
      commit("set_photographers", resp.photographers);
    }
    return resp;
  },
};

const mutations = {
  set_photographers: (state, photographers) => {
    state.photographers = photographers;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
